import Vue from 'vue';
import Vuex from 'vuex';
import webRoute from "../common/route.js"
import {
    Encrypt
} from "@/common/utils.js"; // 消息加密

Vue.use(Vuex);

const webKey = 'novelAdmin_'   //这个变量 每个网网站 都要改
const key = webKey + 'store_adminInfo' ;
const key1 = webKey + 'store_navList';
const key2 = webKey + 'store_tags' ;
const key3 = webKey + 'store_routePath';
const isLogin = webKey + 'isLogin';
const store = new Vuex.Store({
    state: {
        isLogin: false,
        //管理员信息
        adminInfo: {
            au_avatar_url: "",
            au_username: ""
        },
        sendState: false, // 发送状态
        handClose: false, // 退出登录状态
        connectState: 0,
        adminArr: [],        //
        tagBagColor: ['#18c562', '#409eff', '#67c23a', '#909399', '#f56c6c', '#e6a23c', '#a28558', '#a2589d', '#e20fd4', '#282fd4', '#9599f1', '#0a0b2f', '#090fcc', '#cc0941', '#9e1c41'],
        //侧边栏
        navList: [],
        //head 标签  
        tags: [],
        //head 顶部路由
        routePath: []
        
    },
    getters: {
        getUser(state) {
            if (localStorage.getItem(key) != undefined) {
                state.adminInfo = JSON.parse(localStorage.getItem(key));
            }
            return state.adminInfo
        },
        //获取最新的侧边栏路由信息--admin.vue用
        getNavList(state) {
            if (localStorage.getItem(key1) != undefined) {
                state.navList = JSON.parse(localStorage.getItem(key1));
            }else {
                //首次同步基础数据
                state.navList = webRoute.storeData.navList
                localStorage.setItem(key1, JSON.stringify(webRoute.storeData.navList))
            }
            return state.navList
        },
        //获取最新的head标签信息--admin.vue用
        getTags(state) {
            if (localStorage.getItem(key2) != undefined) {
                state.tags = JSON.parse(localStorage.getItem(key2));
            } else {
                //首次同步基础数据
                state.tags = webRoute.storeData.tags
                localStorage.setItem(key2, JSON.stringify(webRoute.storeData.tags))
            }
            return state.tags
        },
        //获取最新的面包屑信息数据--admin.vue用
        geTroutePath(state) {
            if (localStorage.getItem(key3) != undefined) {
                state.routePath = JSON.parse(localStorage.getItem(key3));
            } else {
                //首次同步基础数据
                state.routePath = webRoute.storeData.routePath
                localStorage.setItem(key3, JSON.stringify(webRoute.storeData.routePath))
            }
            return state.routePath
        },
        // 获取登录状态
        isLogin(state) {
            if (localStorage.getItem(isLogin) != undefined) {
                state.isLogin = localStorage.getItem(isLogin);
            }
            return state.isLogin
        },
        // 获取登录状态
        getweidu_arrList(state) {
            return state.weidu_arrList
        },
    },
    mutations: {
        //初始化标签，左边导航选中，面包屑 ----也是保存数据，以common/route.js 里的 基础数据
        initCacheFun(state) {
            this.commit('setNavList', webRoute.storeData.navList)
            this.commit('setTags', webRoute.storeData.tags)
            this.commit('setroutePath', webRoute.storeData.routePath)
        },
        //保存本地--以state数据为基准
        setLocastrogeFun(state) {
            this.commit('setNavList', state.navList)
            this.commit('setTags', state.tags)
            this.commit('setroutePath', state.routePath)
        },
        //保存本地
        setNavList(state, data) {
            state.navList = data;
            localStorage.setItem(key1, JSON.stringify(data))
        },
        //保存本地
        setTags(state, data) {
            state.tags = data;
            localStorage.setItem(key2, JSON.stringify(data))
        },
        //保存本地
        setroutePath(state, data) {
            state.routePath = data;
            localStorage.setItem(key3, JSON.stringify(data))
        },
        //删除tag
        closeTags(state, obj) {
            state.tags.splice(state.tags.indexOf(obj), 1)
            this.commit('setLocastrogeFun')
        },
        //修改tag
        editTagsCloseIcon(state, obj) {
            if (state.tags.length > 0 && state.tags[obj.index] != undefined) {
                state.tags[obj.index].closeIcon = obj.status
                this.commit('setLocastrogeFun')
            }
        },
        //点击head 标签 ，修改tag/左边导航
        editTagsIsCourrentWeb(state, obj) {
            state.routePath = []   //修改head 顶部路由
            //head圆点高亮
            state.tags.forEach(item => {
                if (item.id == obj.id) {
                    item.isCourrentWeb = true
                } else {
                    item.isCourrentWeb = false
                }
            })
            //左边导航栏高亮
            if (obj.navGrade == 1) {
                //1级导航
                state.navList.forEach(item => {
                    if (item.id == obj.id) {
                        item.isShow = true
                        item.isHover = true
                        state.routePath.push(obj)   //修改head 顶部路由
                    } else {
                        item.isShow = false
						item.isHover = false
                    }
                })
            } else if (obj.navGrade == 2) {
                //2级导航
                state.navList.forEach(item => {
                    if (item.id == obj.p_id) {
                        item.isShow = true
                        item.isHover = true
                        state.routePath.push(item)   //修改head 顶部路由
                        item.children.forEach(item2 => {
                            if (item2.id == obj.id) {
                                item2.isShow = true
                                item2.isHover = true
                                state.routePath.push(item2)  //修改head 顶部路由
                            } else {
                                item2.isShow = false
                                item2.isHover = false
                            }
                        })
                    } else {
                        item.isShow = false
					    item.isHover = false 
                    }
                })
            } 
            this.commit('setLocastrogeFun')
        },
        //添加tag
        addTags(state, obj) {
            let index =parseInt(Math.random()*(15-0+1)+0,10)
            obj.bagColor = state.tagBagColor[index]
            let isHas = state.tags.some(item => {
                if (item.id == obj.id) return true
                return false
            })
            obj.closeIcon = false
            if (!isHas) state.tags.push(obj)
            //点击的当前页面显示圆点，其它隐藏
            state.tags.forEach(item => {
                if (item.id == obj.id) {
                    item.isCourrentWeb = true
                } else {
                    item.isCourrentWeb = false
                }
            })
        },
        //点击左边导航
        tapLeftNavListFun(state, obj) {
            //左边导航栏高亮
            if (obj.navGrade == 1) {
                if(obj.isShow){
                    //展开-》收回
                    //1级导航
                    state.navList.forEach(item => {
                        if (item.id == obj.id) {
                            if (item.children.length > 0) {
                                let sonHover = item.children.filter(item2 => {
                                    return item2.isHover == true
                                })
                                if (sonHover.length > 0) {
                                    item.isShow = false
                                    item.isHover = true
                                } else {
                                    item.isShow = false
                                    item.isHover = false
                                }
                            } else {
                                item.isShow = false
                                item.isHover = false
                            }
                        } else {
                            if (obj.children.length > 0) {
                            } else {
                                item.isShow = false
                                item.isHover = false
                                if (item.children.length > 0) {
                                    item.children.forEach(item2 => {
                                        item2.isShow = false
                                        item2.isHover = false
                                        item2.isCourrentWeb = false
                                    })
                                }
                            }
                        }
                    })
                } else {
                    //收回-》展开
                    state.navList.forEach(item => {
                        if (item.id == obj.id) {
                            item.isShow = true
                            item.isHover = true
                            if (item.children.length == 0) { 
                                state.routePath = []   //修改head 顶部路由
                                state.routePath.push(item)   //修改head 顶部路由
                            }
                        } else {
                            if (obj.children.length > 0) {
                            } else {
                                item.isShow = false
                                item.isHover = false
                                if (item.children.length > 0) {
                                    item.children.forEach(item2 => {
                                        item2.isShow = false
                                        item2.isHover = false
                                        item2.isCourrentWeb = false
                                    })
                                }
                            }
                        }
                    })
                }
            } else if (obj.navGrade == 2) {
                //2级导航
                state.routePath = []   //修改head 顶部路由
                state.navList.forEach(item => {
                    if (item.id == obj.p_id) {
                        item.isShow = true
                        item.isHover = true
                        state.routePath.push(item)   //修改head 顶部路由
                        item.children.forEach(item2 => {
                            if (item2.id == obj.id) {
                                item2.isShow = true
                                item2.isHover = true
                                state.routePath.push(item2)   //修改head 顶部路由
                            } else {
                                item2.isShow = false
                                item2.isHover = false
                            }
                        })
                    } else {
                        item.isShow = false
					    item.isHover = false 
                    }
                })
            } 
            this.commit('setLocastrogeFun')
        },
        /**
		 * 鼠标移入左边导航
		 * obj.data  当前索引数据
		 * obj.index 1级导航的索引
		 */
        mouseOverNavLeftFun(state, obj) {
            if(obj.data.navGrade == 1){
				//1级导航
				state.navList.filter(item => {
                    if (item.id == obj.data.id) {
                        item.isHover = true
                    }
				})
			}else if(obj.data.navGrade == 2){
                //2级导航
				state.navList[obj.index].children.filter(item => {
					 if (item.id == obj.data.id) {
                        item.isHover = true
                    }
				})
			}
        },
        /**
		 * 鼠标移出左边导航
		 * data  当前索引数据
		 * index 1级导航的索引
		 */
        mouseLeaveNavLeftFun(state, obj) {
            if(obj.data.navGrade == 1){
				//1级导航
				state.navList.filter(item => {
                    if (item.id == obj.data.id) {
                        if(obj.data.children.length == 0){
                            if(!obj.data.isShow){
                                item.isHover = false
                            }
                        }else{
                            if (obj.data.isShow) {
                                //展开状态高亮显示
                                item.isHover = true 
                            }else {
                                //非展开状态，判断children 是否有高亮
                                let isCourrentWeb =  obj.data.children.filter(item3 => {
                                    if (item3.isCourrentWeb == true) {
                                        item.isHover = true 
                                    }
                                    return item3.isCourrentWeb == true
                                   
                                })
                                if (isCourrentWeb.length == 0) {
                                    item.isHover = false
                                }
                            }
                        }
                    }
				})
			}else{
				//2级导航
				state.navList[obj.index].children.filter(item => {
                    if (item.id == obj.data.id) {
                        //如果点击过，则鼠标移出，还是选中状态
                        if(!obj.data.isShow){
                            item.isHover = false
                        }
                    }
				})
			}
        },
        //更改数据
        updataAdminArr(state, arr) {
            state.adminArr = arr
        },
      
        setUser(state, data) {
            state.adminInfo = data;
            localStorage.setItem(key, JSON.stringify(data))
        },
        // 设置登录状态
        userStatus(state, flag) {
            state.isLogin = flag;
            localStorage.setItem(isLogin, flag)
        },
        
    },
    actions: {
        userLogin({
            commit
        }, data) {
            commit("userStatus", data)
        },
    }
})
export default store;